import { Link } from "react-router-dom";
import { latestUpdates } from "@/mocks/comics";

export default function LatestUpdates() {
  return (
    <section className="bg-background-100 py-12">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h3
              className="text-xl md:text-2xl font-bold text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              最近更新
            </h3>
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
          </div>
          <Link
            to="/category/completed"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {latestUpdates.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  title={`${comic.title} - 免费漫画下拉式观看`}
                />
                {comic.hot && (
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-red-500 text-[10px] font-bold text-white">
                    HOT
                  </div>
                )}
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
                  <span className="text-xs text-white font-medium">
                    {comic.latestChapter}
                  </span>
                </div>
              </div>
              <h4 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                {comic.title}
              </h4>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.updateTime} 更新</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}